import { render, staticRenderFns } from "./Anticoagulation.vue?vue&type=template&id=5bc98c02&scoped=true&"
import script from "./Anticoagulation.vue?vue&type=script&lang=js&"
export * from "./Anticoagulation.vue?vue&type=script&lang=js&"
import style0 from "./Anticoagulation.vue?vue&type=style&index=0&id=5bc98c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc98c02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VChip,VCombobox,VFlex,VLayout})
